import api from './api';

export interface ConfigEntry {
  key: string;
  label: string;
  group: string;
  type: 'string' | 'secret' | 'boolean';
  description?: string;
  source: 'tenant' | 'global' | 'env' | 'unset';
  isSet: boolean;
  value?: string; // nur für Nicht-Secrets
}

class ConfigService {
  async getConfig(): Promise<ConfigEntry[]> {
    const res = await api.get('/config');
    return res.data;
  }

  async setConfig(key: string, value: string): Promise<void> {
    await api.put(`/config/${encodeURIComponent(key)}`, { value });
  }

  async resetConfig(key: string): Promise<void> {
    await api.delete(`/config/${encodeURIComponent(key)}`);
  }
}

const configService = new ConfigService();
export default configService;
